import { render, staticRenderFns } from "./access.vue?vue&type=template&id=7f8370dc&scoped=true&"
import script from "./access.js?vue&type=script&lang=js&"
export * from "./access.js?vue&type=script&lang=js&"
import style0 from "./access.css?vue&type=style&index=0&id=7f8370dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8370dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
